import React from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import { Chip } from "@mui/material";

import DataTable from "../../../common/DataTable";
import ColumnHeader from "../../../common/ColumnHeader";
import { getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";

const OPNDeactivateList = ({
  data,
  meta,
  client,
  loading,
  disableRowClick,
  handlePageChange,
  handleColumnClick,
  handlePageSizeChange,
  ...props
}) => {
  const nav = useNavigate();
  const handleRowClick = (e) => {
    nav(`/opn/deactivate/${e.row.id}`);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "iccid",
      headerName: "ICCID",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: () =>
        client ? (
          <ColumnHeader
            label={"ICCID"}
            handleClick={() => handleColumnClick("iccid")}
          />
        ) : (
          "ICCID"
        ),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      flex: 2,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
      sortable: false,
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      loading={loading}
      data={data}
      client={client}
      columns={client ? columns.map((val) => ({ ...val, sortable: true })) : columns}
      metaData={meta}
      handleRowClick={disableRowClick ? null : handleRowClick}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      filterMode={client ? "client" : "server"}
      {...props}
    />
  );
};

export default OPNDeactivateList;


